import dayjs from 'dayjs'
export default {
  methods: {
    validateFechas (inicio, fin) {
      if (dayjs(inicio).isBefore(fin)) {
        return true
      }
      window.alert('Las fechas no son correctas')
      return false
    }
  }
}
